import { render } from "./HistoryEdit.vue?vue&type=template&id=d3de5b32"
import script from "./HistoryEdit.vue?vue&type=script&lang=js"
export * from "./HistoryEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Working\\GLMA\\baik\\baicpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__